// extracted by mini-css-extract-plugin
export var circle = "_dl-1";
export var exitConfirmationModal = "_dl-5";
export var iframe = "_dl-0";
export var offline = "_dl-3";
export var online = "_dl-2";
export var workstationSelectError = "_dl-4";